function pluralize(target) {
  if (target === null || target === undefined) {
    return []
  }

  return Array.isArray(target) ? target : [target]
}

export default pluralize



// WEBPACK FOOTER //
// ./src/services/utils/pluralize.js